/* Shared, side-effect-free cart arithmetic. Theme feedback is not checkout enforcement. */
(function (root) {
  const PLUG = 'MILES-PLUG';
  const TERMS = ['MILES-GUARD-1YR', 'MILES-GUARD-2YR', 'MILES-GUARD-3YR'];
  function summarize(cart) {
    const counts = [0, 0, 0];
    let plugs = 0;
    for (const item of cart.items || []) {
      if (item.sku === PLUG) plugs += item.quantity;
      const index = TERMS.indexOf(item.sku);
      if (index !== -1) counts[index] += item.quantity;
    }
    return { plugs, counts, memberships: counts.reduce((sum, count) => sum + count, 0) };
  }
  function validTermCounts(counts) {
    return Array.isArray(counts) && counts.length === 3 && counts.every((count) => Number.isSafeInteger(count) && count >= 0);
  }
  function validCounts(plugs, counts, allowMembershipOnly = false) {
    if (!validTermCounts(counts)) return false;
    const total = counts.reduce((sum, count) => sum + count, 0);
    return allowMembershipOnly ? total >= plugs : total === plugs;
  }
  function fingerprint(cart) {
    return JSON.stringify((cart.items || []).map((item) => [item.key, item.quantity]).sort());
  }
  function updatesFor(cart, catalog, counts) {
    // Cart editing may temporarily leave a Plug without coverage. Enforce the
    // one-per-Plug pairing at checkout, not while saving membership quantities.
    if (!validTermCounts(counts)) throw new Error('quantity');
    const updates = {};
    TERMS.forEach((sku, index) => {
      const lines = cart.items.filter((item) => item.sku === sku);
      const variant = catalog[index];
      if (counts[index] > 0 && (!variant?.id || !variant.available || variant.sku !== sku)) throw new Error('unavailable');
      // Preserve separate line properties (including gifts); never overwrite unrelated products.
      let remaining = counts[index];
      for (const line of lines) {
        const quantity = Math.min(remaining, line.quantity);
        updates[line.key] = quantity;
        remaining -= quantity;
      }
      if (remaining > 0) {
        const key = lines.length ? lines[0].key : String(variant.id);
        updates[key] = (updates[key] || 0) + remaining;
      }
    });
    return updates;
  }
  const api = { PLUG, TERMS, summarize, validTermCounts, validCounts, fingerprint, updatesFor };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MilesCartModel = api;
})(typeof window === 'undefined' ? {} : window);
